import loadable from '@loadable/component'
import React from 'react'
import { FeatureToggle } from '../../../feature-toggling/Toggle/Toggle'
import { TheWestLivePlayerPageProps } from './TheWestLivePlayerPage'

const LazyTheWestLivePlayerComponent = loadable(
    () => import('./TheWestLivePlayerPage'),
)

// Standalone lazy load component
export const LazyTheWestLivePlayerPage = (
    props: TheWestLivePlayerPageProps,
) => {
    return (
        <FeatureToggle
            feature="the-west-live"
            on={() => <LazyTheWestLivePlayerComponent {...props} />}
        />
    )
}
